import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header/Header.jsx"
const Layout = ({ children }) => (
  <div>
    <Header />
    <div>
      <Outlet/>
      </div>
       {/* Ensures that the routes render correctly */}
  </div>
);

export default Layout;

